import React, { useState } from "react";
import "./styles.css";
import Map from "./Map";
import image from "./img/ChatGPT Image Mar 26, 2026, 09_06_47 AM (2).png";
import g7white1 from "./G7 White/4e27afa545bcfa0c2aa135ed9320db19.png";
import g7white2 from "./G7 White/WhatsApp Image 2026-04-17 at 10.52.32 (1).jpeg";
import g7white3 from "./G7 White/WhatsApp Image 2026-04-17 at 10.52.31 (1).jpeg";
import g7white4 from "./G7 White/WhatsApp Image 2026-04-17 at 10.52.31 (2).jpeg";
import g7white5 from "./G7 White/WhatsApp Image 2026-04-17 at 10.52.32 (2).jpeg";
import g7black1 from "./G7 Black/ChatGPT Image Apr 17, 2026, 11_30_13 AM.png";
import g7black2 from "./G7 Black/WhatsApp Image 2026-04-17 at 10.52.31 (1).jpeg";
import g7black3 from "./G7 Black/WhatsApp Image 2026-04-17 at 10.52.31.jpeg";
import g7black4 from "./G7 Black/WhatsApp Image 2026-04-17 at 10.52.32.jpeg";
import g7black5 from "./G7 Black/WhatsApp Image 2026-04-17 at 10.52.36.jpeg";
import g71 from './G7 Silver/ChatGPT Image Apr 27, 2026, 10_37_27 AM.png';
import g72 from './G7 Silver/WhatsApp Image 2026-04-27 at 10.17.13 (7).jpeg';
import g73 from './G7 Silver/WhatsApp Image 2026-04-27 at 10.17.14 (5).jpeg';
import g74 from './G7 Silver/WhatsApp Image 2026-04-27 at 10.17.19 (3).jpeg';
import g75 from './G7 Silver/WhatsApp Image 2026-04-27 at 10.17.11.jpeg';
import b1 from './Benzz/1277982a-2777-4b51-93a0-cb375e84195f.png';
import b2 from './Benzz/WhatsApp Image 2026-04-27 at 10.17.11 (2).jpeg';
import b3 from './Benzz/WhatsApp Image 2026-04-27 at 10.17.15 (1).jpeg';
import b4 from './Benzz/WhatsApp Image 2026-04-27 at 10.17.15 (6).jpeg';
import t1 from './Toyota/ChatGPT Image Apr 27, 2026, 11_04_12 AM.png';
import t2 from './Toyota/WhatsApp Image 2026-04-27 at 10.17.19 (1).jpeg';
import t3 from './Toyota/WhatsApp Image 2026-04-27 at 10.17.19 (4).jpeg';
import t4 from './Toyota/WhatsApp Image 2026-04-27 at 10.17.15 (5).jpeg';
import bb1 from './Benz/ChatGPT Image Apr 27, 2026, 11_07_32 AM.png';
import bb2 from './Benz/WhatsApp Image 2026-04-27 at 10.17.18 (5).jpeg';
import bb3 from './Benz/WhatsApp Image 2026-04-27 at 10.17.16 (2).jpeg';
import bb4 from './Benz/WhatsApp Image 2026-04-27 at 10.17.19 (7).jpeg';

export default function CarRentalPage() {
  const [selectedCar, setSelectedCar] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false); // NEW

  const cars = [
    { id: 1, 
      name: "Volkswagen Golf 7",
      price: 50, 
      images: [g7white1, g7white2,g7white3,g7white4,g7white5], 
      description: "⚙ 2.0 Diesel I rehatshem dhe ekonomik.",}, 
    { id: 2, 
      name: "Volkswagen Golf 7", 
      price: 50, 
      images: [g7black1,g7black4,g7black3,g7black2,g7black5], 
      description: "⚙ 2.0 Diesel I rehatshem dhe ekonomik", }, 
    { id: 3, 
      name: "Volkswagen Golf 7", 
      price: 50, 
      images: [g71,g72,g73,g74,g75], 
      description: "⚙ 2.0 Diesel I rehatshem dhe ekonomik", }, 
    { id: 4, 
      name: "Benz-Mercedez S Class", 
      price: '', 
      images: [b1,b2,b3,b4], 
      description: "Makine ekonomike dhe praktike, perfekte per qytet dhe udhetime te shkurtra.", }, 
    { id: 5, 
      name: "Toyota 4x4", 
      price: 40, 
      images: [t1,t2,t3,t4], 
      description: "Makine ekonomike dhe praktike, perfekte per qytet dhe udhetime te shkurtra.", }, 
    { id: 6, name: "Benz-Mercedez C Class", 
      price: 25, 
      images: [bb1,bb2,bb3,bb4], 
      description: "Makine ekonomike dhe praktike, perfekte per qytet dhe udhetime te shkurtra.", }, 
    
  ];

  const handleWhatsApp = (car) => {
    const message = `Pershendetje, dua te rezervoj ${car.name}`;
    window.open(
      `https://wa.me/355698133611?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) =>
      prev === selectedCar.images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? selectedCar.images.length - 1 : prev - 1
    );
  };

  return (
    <div className={selectedCar ? "blurred" : ""}>

      {/* Navbar */}
      <header className="navbar">
        <h1 className="logo">
          <img src={image} alt="logo" />
        </h1>

        {/* DESKTOP NAV */}
        <nav className="nav-links">
          <a href="#">Home</a>
          <a href="#cars">Makinat</a>
          <a href="#contact">Kontakt</a>
        </nav>

        {/* HAMBURGER */}
        <div
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </div>
      </header>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="mobile-menu">
          <a href="#" onClick={() => setMenuOpen(false)}>Home</a>
          <a href="#cars" onClick={() => setMenuOpen(false)}>Makinat</a>
          <a href="#contact" onClick={() => setMenuOpen(false)}>Kontakt</a>
        </div>
      )}

      {/* Hero */}
      <section className="hero">
        <div className="overlay">
          <h2>Noah's Car Rental</h2>
          <p>Makina moderne, komode dhe ekonomike</p>
          <button onClick={() => handleWhatsApp({ name: "nje makine" })}>
            Rezervo Tani
          </button>
        </div>
      </section>

      {/* Cars */}
      <section id="cars" className="cars">
        <h2>Makinat Tona</h2>

        <div className="car-grid">
          {cars.map((car) => (
            <div
              key={car.id}
              className="car-card"
              onClick={() => {
                setSelectedCar(car);
                setCurrentImageIndex(0);
              }}
            >
              <img src={car.images[0]} alt={car.name} />
              <h3>{car.name}</h3>
              <p className="price">€{car.price} / ditë</p>
              <button onClick={(e) => {
                e.stopPropagation();
                handleWhatsApp(car);
              }}>
                Rezervo
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="contact">
        <h2>Na Kontaktoni</h2>
        <p>📍 Shijak, Albania<br/>
        Rruga 8 Dhjetori, Ura Sul Golemi, Sallmone</p>
        <p>📞 +355 69 813 3611</p>
        <Map/>
      </section>

      {/* MODAL */}
      {selectedCar && (
        <div className="modal" onClick={() => setSelectedCar(null)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <span className="close" onClick={() => setSelectedCar(null)}>
              ✖
            </span>

            {/* Image Slider */}
            <div className="slider">
              <button onClick={prevImage}>‹</button>
              <img
                src={selectedCar.images[currentImageIndex]}
                alt=""
              />
              <button onClick={nextImage}>›</button>
            </div>

            <h2>{selectedCar.name}</h2>
            <p className="price">€{selectedCar.price} / ditë</p>
            <p>{selectedCar.description}</p>

            <button className="btnn" onClick={() => handleWhatsApp(selectedCar)}>
              Rezervo në WhatsApp
            </button>
          </div>
        </div>
      )}
    </div>
  );
}